var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00015 0.525146H5.02515C2.53987 0.525146 0.525146 2.53986 0.525146 5.02514V8.97515C0.525146 11.4604 2.53986 13.4751 5.02514 13.4751H8.97515C11.4604 13.4751 13.4751 11.4604 13.4751 8.97515V7.00015",
    stroke: "#213332",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30306 1.5468C10.1573 0.692524 11.5424 0.692524 12.3966 1.5468V1.5468C13.2509 2.40107 13.2509 3.78612 12.3966 4.64039L7.52155 9.51548C7.27343 9.76361 6.94616 9.91689 6.5967 9.94866L5.5272 10.0459C4.5943 10.1307 3.81275 9.34915 3.89756 8.41625L3.99478 7.34675C4.02655 6.99728 4.17984 6.67002 4.42796 6.42189L9.30306 1.5468Z",
    stroke: "#213332"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.1875V2.1875C9.30876 3.58439 10.4156 4.69124 11.8125 5.25V5.25",
    stroke: "#213332",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7bd5e8d9925d8e26bd3d467f15144853.svg";
export { ForwardRef as ReactComponent };